import $ from 'jquery';
import { fabric } from 'fabric';
import { showSidebarTab } from '~src/sidebarLegacy';
import { hideAllMenus } from '~core/hideAllMenus';
import { getState, modifyState } from '~src/state';
import { getImageSize } from '~src/sidebar';
import { initMagicEraser, initMagicEraserCanvases } from '~core/magicEraser';
import { getCanvasBaseZoom } from '~loader/loader-utils';
import { toggleSaveNavMenu } from '~core/navbar';
import { deselectObjects } from '~src/ui';
import Swal from 'sweetalert2';
import { prepareImageForEditing } from '~core/image';
import { isPlaceholderEditing } from '~core/magicFrame';
import { checkAiCreditsBeforeUse } from '~core/aiCredits';
import { getGlobalControlsManager } from '~core/customControls';

export const startMagicEraser = async () => {
  // Check credits before entering the feature
  const hasCredits = await checkAiCreditsBeforeUse({
    featureName: 'Magic Eraser',
    requiredCredits: 1,
  });

  if (!hasCredits) {
    return;
  }

  let selection = window.canvas.getActiveObject();
  if (selection.type === 'MagicFrame') {
    selection = selection.editingImg;
  }

  if (isPlaceholderEditing(selection)) {
    return;
  }

  modifyState('magicEraserSelection', selection);
  const imageUrl = await prepareImageForEditing(selection, false);
  if (!imageUrl) {
    console.error('No image URL found in current selection', selection);
    return;
  }

  Swal.fire({
    title: "Preparazione dell'ambiente di lavoro...",
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
    showConfirmButton: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });

  const size = await getImageSize(imageUrl);

  initMagicEraserCanvases({
    width: size.w,
    height: size.h,
  });
  const zoom = getCanvasBaseZoom(size.w, size.h);
  initMagicEraser();

  $('#editor-zoom-controls').hide();
  modifyState('stopKeyboardListener', true);
  modifyState('isMagicEraserActive', true);
  modifyState('magicEraserTarget', selection);
  showSidebarTab('image-magic-eraser');
  hideAllMenus();
  deselectObjects();
  toggleSaveNavMenu();
  $('#editor-menu-run-magic-eraser').attr('disabled', true);
  // $('#editor-menu-apply-magic-eraser').attr('disabled', true); // Button deprecated
  // Hide floating controls while working on the magic eraser canvases
  try {
    const cm = getGlobalControlsManager();
    cm && cm.hideAllControls();
  } catch (e) {
    console.error('Failed hiding controls when starting Magic Eraser', e);
  }

  $('#main-canvas-container').fadeOut(() => {
    $('#canvas-zoom').css('transform', `scale(${zoom})`);
    $('#magic-eraser-container').show();
    $('#drawing-magic-eraser-canvas').fadeIn();
  });
  $('#manipulation-magic-eraser-canvas').hide();

  window.brushCanvas = document.querySelector('#brush-canvas');

  modifyState('magicEraserTargetImageUrl', imageUrl);

  new fabric.Image.fromURL(
    imageUrl,
    (img) => {
      img.set({
        selectable: false,
        evented: false,
        crossOrigin: 'anonymous',
      });
      img.scaleToHeight(window.magicEraserDrawingCanvas.height);
      window.magicEraserDrawingCanvas.add(img);
      window.magicEraserDrawingCanvas.centerObject(img);
      img.sendToBack();
      window.magicEraserDrawingCanvas.requestRenderAll();

      // Init mask
      const mask = new fabric.Rect({
        left: 0,
        top: 0,
        scaleX: 1,
        scaleY: 1,
        width: img.width * img.scaleX,
        height: img.height * img.scaleY,
        fill: 'black',
      });

      const brushRadius = getState('magicEraserBrushRadius');

      window.magicEraserDrawingCanvas.isDrawingMode = true;
      window.magicEraserDrawingCanvas.freeDrawingBrush.width = brushRadius * 2;
      window.magicEraserDrawingCanvas.freeDrawingBrush.inverted = true;

      window.magicEraserManipulationCanvas.isDrawingMode = true;
      window.magicEraserManipulationCanvas.add(mask);
      window.magicEraserManipulationCanvas.centerObject(mask);
      window.magicEraserManipulationCanvas.requestRenderAll();

      Swal.close();
    },
    { crossOrigin: 'anonymous' }
  );
};
